import Register from "../../section/auth/Register";

export default function RegisterPage(){
    return(
        <Register />
    )
}